import { gql } from '@generated/gql';

const getLocalSessionAddress = gql(`
  query GetLocalSessionAddressDetails($basketId: ID!) {
    basket(id: $basketId) {
      id
      details {
        accountId
        occupancyType
        supplyAddress {
          buildingName
          buildingNumber
          county
          dependentThoroughfare
          doubleDependentLocality
          id
          organisation
          postTown
          postcode
          subBuilding
          thoroughfare
        }
      }
    }
  }
`);

const getRetrievedBasket = gql(`
  query RetrieveSavedBasket($input: RetrievedSavedBasketInput!) {
    retrieveSavedBasket(input: $input) {
      basket {
        id
        details {
          createdAt
          occupancyType
          supplyAddress {
            postcode
          }
        }
      }
    }
  }
`);

export { getLocalSessionAddress, getRetrievedBasket };
